import { React, useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

function Services() {
	const [open1, setOpen1] = useState(true);
	const [open2, setOpen2] = useState(false);
	const [open3, setOpen3] = useState(false);

	return (
		<div id='Services' className='isolate bg-gray-900 py-20 sm:py-20 '>
			<div className='relative mx-auto max-w-7xl px-4 lg:px-16'>
				<div className='mx-auto grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2'>
					<div className='lg:pr-8'>
						<div className='md:max-w-lg md:pr-10 lg:max-w-lg lg:pr-30'>
							<div className='hidden sm:flex sm:justify-left'>
								<div className='border-b-8 border-white w-32 my-6'></div>
							</div>
							<p className='mt-2 text-4xl font-bold tracking-tight text-white sm:text-6xl text-center sm:text-left'>
								SERVICES I OFFER
							</p>
							<p className='mt-6 text-lg leading-8 text-gray-400'>
								As a software engineer, I offer a variety of services to help
								businesses and individuals achieve their goals through
								technology. Here are some of the services I specialize in 👉
							</p>
						</div>

						<div className='absolute left-26 z-50 pt-10 md:block hidden'>
							<a href='#Portfolio'>
								<div className='bg-white  rounded-full p-6 cursor-pointer hover:bg-indigo-600 '>
									<FaAngleDown size={26} />
								</div>
							</a>
						</div>
					</div>

					<div className=' pt-0 md:pt-0'>
						<div
							className='border-b border-gray-200 pb-4 mb-4 mt-4 sm:mt-4'
							onClick={() => setOpen1(!open1)}>
							<p className='text-4xl font-bold tracking-tight text-gray-300 flex items-center'>
								<span className='inline-block align-middle mr-2 text-6xl font-bold text-gray-200'>
									01
								</span>
								<span className='font-medium align-middle'>
									Website Development
								</span>
								{open1 ? (
									<FaAngleDown className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' />
								) : (
									<FaAngleUp className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' />
								)}
							</p>
							{open1 && (
								<p className='mt-4 text-base leading-6 text-gray-400'>
									I specialize in creating high-quality websites that are
									optimized for speed, security, and user experience. Whether
									you need a simple brochure website or a complex web
									application, I can help you create a website that meets your
									specific needs.
								</p>
							)}
						</div>

						<div
							className='border-b border-gray-200 pb-4 mb-4'
							onClick={() => setOpen2(!open2)}>
							<p className='mt-4 text-4xl font-bold tracking-tight text-gray-300 flex items-center'>
								<span className='inline-block align-middle mr-2 text-6xl font-bold text-gray-200'>
									02
								</span>
								<span className='font-medium align-middle'>
									Mobile App Development
								</span>
								{open2 ? (
									<FaAngleDown className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' />
								) : (
									<FaAngleUp className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' />
								)}
							</p>

							{open2 && (
								<p className='mt-4 text-base leading-6 text-gray-400'>
									I can help you create a mobile app that will help you reach
									more customers and engage with them in new ways. From design
									to development to launch, I can help you create a mobile app
									that will help you grow your business.
								</p>
							)}
						</div>

						<div className='pb-4 mb-4' onClick={() => setOpen3(!open3)}>
							<p className='mt-4 text-4xl font-bold tracking-tight text-gray-300 flex items-center'>
								<span className='inline-block align-middle mr-2 text-6xl font-bold text-gray-200'>
									03
								</span>
								<span className='font-medium align-middle'>
									Software Consulting
								</span>
								{open3 ? (
									<FaAngleDown className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' />
								) : (
									<FaAngleUp className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' />
								)}
							</p>
							{open3 && (
								<p className='mt-4 text-base leading-6 text-gray-400'>
									I offer software consulting services to help you evaluate your
									current software infrastructure and identify areas for
									improvement. Whether you need help with software architecture,
									performance optimization, or security, I can help you make the
									right decisions to achieve your goals.
								</p>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Services;
